module.exports = __webpack_public_path__ + "img/pic222.78948b22.png";